(function($) {
    const currentActive = $('.navbar .nav-item').find('.active').attr('id');
    let newActive;

    // Toggle collapse on submenu
    $('.dropdown').on('click', function(e) {
        e.stopPropagation();

        $('.dropdown-menu,.dropdown-toggle').removeClass('show');

        if ($(this).hasClass("is-parent") ) {
            //If main navigation already has active state - when clicked - lets remove active class and hide dropdown
            $(this).removeClass('is-parent');
            $(this).find('.dropdown-menu,.dropdown-toggle').removeClass('active show');
        }else{
            //If main navigation doesn't have active state - lets show dropdown and active class
            $(this).find('.dropdown-menu,.dropdown-toggle').addClass('show');
            $('.dropdown-menu,.dropdown-toggle').not('#' + currentActive).removeClass('active');

            if ($(this).find('.dropdown-menu,.dropdown-toggle').hasClass("active") ) {
                //If page load has current active class
                if (newActive != currentActive){
                    $('#' + newActive).removeClass('active');

                    if($(this).find('.dropdown-menu,.dropdown-toggle').hasClass('show')){
                        $(this).addClass('is-parent');
                    }else{
                    }
                }else{
                    // If clicking on active toggle - remove dropdown
                    $(this).find('.dropdown-menu,.dropdown-toggle').removeClass('active show');
                }
            }else{
                $('.dropdown').removeClass('is-parent');
                $(this).addClass('is-parent');
                $(this).find('.dropdown-toggle').addClass('active show');
                window.newActive = $(this).find('.dropdown-toggle').attr('id');
            }
        }
    });

    //prevent dropdown from closing when clicking inside dropdown menu
    $('.site-header .dropdown-menu,.site-header .dropdown').on('click', function(e) {
        console.log('stopped');
        e.stopPropagation();
        e.preventDefault();
    });

    $('.footer-link a').on('click', function(e) {
        window.location = $(this).attr('href');
    });

    $('body').on('click', function(e) {
        var dropdownMenu = $('.dropdown-menu');
        if(dropdownMenu !== event.target && !dropdownMenu.has(event.target).length){
            $('.dropdown-menu,.dropdown-toggle').removeClass('show');
            $('.dropdown').removeClass('is-parent');
            if (newActive != currentActive){
                $('#' + newActive).removeClass('active');
            }
            $('.dropdown-menu,.dropdown-toggle').not('#' + currentActive).removeClass('active');
        }
    });

    $('.mobile-back,.js-close-dropdown').on('click', function(e) {
        e.stopPropagation();
        $('.dropdown-menu,.dropdown-toggle').removeClass('show');
        if (newActive != currentActive){
            $('#' + newActive).removeClass('active');
        }
    });

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-expanded')) {
            primaryNavigation.removeClass('is-expanded');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');
            $this.attr('aria-expanded', 'false');

        } else {
            primaryNavigation.addClass('is-expanded');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
            $this.attr('aria-expanded', 'true');
        }
    });

    $('.drop-col').on('click', function(e) {
        e.stopPropagation();

        if($(this).find('.dropdown-list').hasClass("show")) {
            console.log(this);
            $(this).find('.dropdown-list').removeClass('show');
            $(this).find('.text-18-headline').removeClass('rotate-180');
        }else{
            // $('.dropdown-list').removeClass('show');

            $(this).find('.dropdown-list').addClass('show');
            $(this).find('.text-18-headline').addClass('rotate-180');
        }
    });



}(jQuery));